import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Avatar1 from '../../assets/new-right-menu/profile.svg'
import messages from '../../assets/new-right-menu/email.svg'
import setting from '../../assets/new-right-menu/settings.svg'
import exitIcon from '../../assets/new-right-menu/onOff.svg'
import { ROUTE_LOGIN, ROUTE_NOTIFICATIONS, ROUTE_USER_PROFILE } from '../../routes/routes-constants'
import { getUserContainer } from 'container/user-module'
import { ILoggedUserService } from '../../modules/users/services/LoggedUserService'
import { IUserService, LOGGED_USER_SERVICE_KEY, USER_SERVICE_KEY } from '../../modules/users'
import styles from '../header/Header.module.css'
import { User } from '../../modules/users/models/User'
import { Avatar } from '@mui/material'
import style from '../avatar-profile/AvatarProfile.module.css'
import { getFileContainer } from '../../container/file-module'
import { FileService } from '../../modules/files/services/FileService'
import { FILE_SERVICE_KEY } from '../../modules/files'
import { emptyFileDTO } from '../../modules/files/models/FileDTO'
import { useProfilePhotoGlobalContext } from '../../common/utils/ProfilePhotoContext'
import { useNavigate } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { useNotificationsContext } from '../../common/utils/NotificationsContext'
import { NotificationItem } from '../notification-item/NotificationItem'
import { SendingStatus } from 'modules/notifications/enums/SendingStatus'
import styleNR from './NavRight.module.css'

const filesContainer = getFileContainer()
const fileService = filesContainer.get<FileService>(FILE_SERVICE_KEY)
const loggedUserService = getUserContainer().get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)
const userService = getUserContainer().get<IUserService>(USER_SERVICE_KEY)

type CustomAppBarProps = {
  onChange?: () => void
}

const NavRight = (props: CustomAppBarProps) => {
  const { t } = useTranslation()
  const [user, setUser] = useState<User>()
  const { profilePhoto, setProfilePhoto } = useProfilePhotoGlobalContext()
  const { notifications, unreadCount, markAsRead } = useNotificationsContext()
  const navigate = useNavigate()
  const loggedUser = loggedUserService.get()

  useEffect(() => {
    if (!loggedUser?.id) return

    fileService.getProfilePhotoByUserID(loggedUser.id).subscribe({
      next: (res) => setProfilePhoto(res || emptyFileDTO('')),
      error: (err) => console.error('Error al cargar foto:', err),
    })
  }, [loggedUser])

  useEffect(() => {
    if (!loggedUser?.id) return

    userService.getByID(loggedUser.id).subscribe({
      next: (user) => setUser(user),
      error: () => console.error('Error al cargar usuario'),
    })
  }, [loggedUser])

  const handleSetMenuSelected = (menuSelected: string) => {
    navigate(menuSelected)
  }

  const handleLogout = () => {
    loggedUserService.logout()
    navigate(ROUTE_LOGIN)
    props.onChange?.()
  }

  return (
    <>
      <Dropdown
        bsPrefix="vertical-dropdown"
        className={styles.navRightContainer}
        style={{ marginRight: '-1%' }}
      >
        <Dropdown className={styleNR.navRightContainer} style={{ marginRight: '-1.5%' }}>
          <Dropdown.Toggle
            variant="link"
            id="dropdown-basic"
            style={{ color: 'white' }}
            className="d-flex align-items-center"
          >
            <div className={styleNR.iconMenuContainer}>
              <img src={messages} alt="messages" className={styleNR.iconMenu} />
              {notifications.filter((n) => n.deliveryStatus === SendingStatus.Pending).length >
                0 && (
                <span className={styleNR.notificationsBadge}>
                  {notifications.filter((n) => n.deliveryStatus === SendingStatus.Pending).length}
                </span>
              )}
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="notification">
            <div className={styles.notiHead}>
              <h6 className="d-inline-block m-b-0">{t('notifications')}</h6>
              <div className="float-right">
                <a className={styleNR.viewAll} onClick={() => navigate(ROUTE_NOTIFICATIONS)}>
                  {t('viewAll')}
                </a>
              </div>
            </div>
            <ul className="noti-body">
              {notifications.filter((n) => n.deliveryStatus === SendingStatus.Pending).length >
              0 ? (
                notifications
                  .filter((n) => n.deliveryStatus === SendingStatus.Pending)
                  .slice(0, 5)
                  .map((notification) => (
                    <li key={notification.id} className={styleNR.notification}>
                      <NotificationItem
                        title={notification.title}
                        message={notification.message}
                        date={notification.createdAt}
                        eventType={notification.eventType}
                        deliveryStatus={notification.deliveryStatus}
                        size="small"
                        onClick={() => {
                          if (notification.id) {
                            markAsRead(notification.id)
                          }
                        }}
                      />
                    </li>
                  ))
              ) : (
                <li className="notification">
                  <div className="media">
                    <div className="media-body">
                      <p>{t('noNotifications')}</p>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown.Toggle
          variant="link"
          id="dropdown-basic"
          style={{
            color: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 0,
          }}
        >
          <Avatar
            style={{ width: '100%!important', height: '100%!important' }}
            sx={{ width: '3rem', height: '3rem', marginRight: 1, objectFit: 'cover' }}
            className={style.profilepic__image}
            alt="Remy Sharp"
            src={
              profilePhoto.data.length > 0 ? `data:image/jpg;base64, ${profilePhoto.data}` : Avatar1
            }
          />
        </Dropdown.Toggle>
        <Dropdown.Menu className={styles.profileNotification}>
          <ul className="pro-body">
            <li style={{ cursor: 'pointer' }}>
              <button
                onClick={() => handleSetMenuSelected(ROUTE_USER_PROFILE)}
                className="dropdown-item"
              >
                <img style={{ marginRight: 8 }} src={setting} alt={'profile'} />{' '}
                <span style={{ fontFamily: 'Montserrat-SemiBold', fontSize: 15 }}>
                  {t('profile')}
                </span>
              </button>
            </li>
            <li style={{ cursor: 'pointer' }}>
              <button onClick={handleLogout} className="dropdown-item">
                <img style={{ marginRight: 16 }} src={exitIcon} alt={'exit'} />{' '}
                <span style={{ fontFamily: 'Montserrat-SemiBold', fontSize: 15 }}>{t('exit')}</span>
              </button>
            </li>
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

export default NavRight
